"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsorshipResponse = void 0;
var SponsorshipResponse;
(function (SponsorshipResponse) {
    let state;
    (function (state) {
        state["HIDDEN"] = "hidden";
        state["NEW"] = "new";
        state["VIEWED"] = "viewed";
        state["REQUIREMENTS"] = "requirements";
        state["SETUP"] = "setup";
        state["READY"] = "ready";
        state["READY_SOON"] = "ready_soon";
        state["RUNNING"] = "running";
        state["PENDING_REVIEW"] = "pending_review";
        state["PAYMENT_SETUP"] = "payment_setup";
        state["PAYMENT_SCHEDULED"] = "payment_scheduled";
        state["COMPLETED"] = "completed";
        state["EXPIRED"] = "expired";
        state["REJECTED"] = "rejected";
        state["CANCELED"] = "canceled";
        state["FAILED_TO_MEET_GOALS"] = "failed_to_meet_goals";
        state["READY_FOR_TRACKING"] = "ready_for_tracking";
        state["APPROVED"] = "approved";
    })(state = SponsorshipResponse.state || (SponsorshipResponse.state = {}));
    let deploymentState;
    (function (deploymentState) {
        deploymentState["PENDING"] = "pending";
        deploymentState["OUTREACHING"] = "outreaching";
        deploymentState["OUTREACHED"] = "outreached";
        deploymentState["VIEWED"] = "viewed";
        deploymentState["ACCEPTED"] = "accepted";
        deploymentState["RUNNING"] = "running";
        deploymentState["ADJUSTMENT_APPROVAL"] = "adjustment_approval";
        deploymentState["PAYMENT_PROCESSING"] = "payment_processing";
        deploymentState["OUTREACH_TIMEOUT"] = "outreach_timeout";
        deploymentState["OUTREACH_REJECTED"] = "outreach_rejected";
        deploymentState["CANCELED"] = "canceled";
        deploymentState["FAILED_TO_MEET_GOALS"] = "failed_to_meet_goals";
        deploymentState["COMPLETED"] = "completed";
        deploymentState["ABUSE_IDENTIFIED"] = "abuse_identified";
    })(deploymentState = SponsorshipResponse.deploymentState || (SponsorshipResponse.deploymentState = {}));
    let version;
    (function (version) {
        version["SESP"] = "sesp";
        version["BOSS"] = "boss";
    })(version = SponsorshipResponse.version || (SponsorshipResponse.version = {}));
    let platformType;
    (function (platformType) {
        platformType["TWITCH"] = "twitch";
        platformType["YOUTUBE"] = "youtube";
        platformType["TIKTOK"] = "tiktok";
    })(platformType = SponsorshipResponse.platformType || (SponsorshipResponse.platformType = {}));
    let payoutDestination;
    (function (payoutDestination) {
        payoutDestination["DIRECT"] = "direct";
        payoutDestination["AGENCY"] = "agency";
    })(payoutDestination = SponsorshipResponse.payoutDestination || (SponsorshipResponse.payoutDestination = {}));
})(SponsorshipResponse = exports.SponsorshipResponse || (exports.SponsorshipResponse = {}));
